<template>
    <c-dialog ref="dialog" width="550" mode="slide" mask-close @close="dialogFormEditConfirm($refs.form, arguments)">

        <c-form ref="form" vertical unit-width="100%">
            <c-input type="hidden" name="id"></c-input>

            <c-form-item label="售后工单" required>
                <c-select name="order_id" v-model="order_id" async @search="searchAftersaleOrder" :value-data="orderOptions" :clear="false"></c-select>
                <info-card code="AFTERSALE_ORDER" :id="order_id"></info-card>
            </c-form-item>
            
            <c-form-item label="工单编号">
                <c-input name="order_number" placeholder="请输入，不填将自动生成"></c-input>
            </c-form-item>

            <c-form-item label="紧急程度" required>
                <c-radio-group name="urgency_level" :options="urgencyLevelDic"></c-radio-group>
            </c-form-item>

            <c-form-item label="招工类型" required>
                <c-radio-group name="recruit_type" :options="recruitTypeDic"></c-radio-group>
            </c-form-item>

            <c-form-item label="招工人数" required>
                <c-input type="number" name="recruit_count" decimal="0" :range="[1,999]" append-text="人"></c-input>
            </c-form-item>

            <c-form-item label="上班天数" required>
                <c-input type="number" name="work_days" decimal="1" :range="[0.5,999]" append-text="天"></c-input>
            </c-form-item>

            <c-form-item label="所需费用" required>
                <c-input type="number" name="required_fee" decimal="2" :range="[0,99999]" append-text="天"></c-input>
            </c-form-item>

            <c-form-item label="人员到岗时间" required>
                <c-datetime name="arrival_time" type="date" format="yyyy-MM-dd"></c-datetime>
            </c-form-item>

            <c-form-item label="备注">
                <c-input name="remark" type="textarea" maxlength="1000" :rows="3"></c-input>
            </c-form-item>
        </c-form>
        <template #button>
            <c-button size="form" v-if="!editState || order_status == -1" @click="submitHandle(-1)">暂存草稿</c-button>
            <c-button size="form" color="main" @click="submitHandle(1)">提交数据</c-button>
        </template>
        <workflow-launch ref="workflowLaunch"></workflow-launch>
    </c-dialog>
</template>

<script>
import {mapState} from "vuex";
import workflowLaunch from "@/components/service/workflow_launch.vue";

export default {
    computed: {
        // 获取dictName选项数据
        ...mapState(['recruitTypeDic','urgencyLevelDic'])
    },

    components: {workflowLaunch},

    data() {
        return {
            order_status:-1,                 //申请单状态
            editState: false,
            order_id:0,                     //工单ID
            orderOptions:[],                //工单集合
        }
    },
    methods: {
        /*********打开编辑框，初始化**********/
        async open(data) {
            this.$refs.form.clear();
            this.editState = false;
            if (data) {
                //查询网点详情
                this.request({
                    url:'/outsource/recruit/detail',
                    data: {
                        id:data.id
                    },
                    success:data => {
                        this.$refs.form.set(data.detailInfo);
                        this.order_status = data.detailInfo.status;
                        //已选中【工单】
                        if(data.detailInfo.order_id && data.detailInfo.order_number){
                            this.orderOptions = [{
                                name: data.detailInfo.order_number,
                                value: data.detailInfo.order_id
                            }];
                        }
                    }
                })
                this.editState = true;
            }else{
                this.$refs.form.set({
                    urgency_level: 1
                });
            }
            //填充 form 表单
            this.$refs.dialog.open({
                title: data ? '编辑外协招工' : '新增外协招工'
            });
        },

        /*******搜索【售后工单】下拉框信息*****************/
        searchAftersaleOrder(keyword, resolve){
            this.request({
                url:'/system/options',
                data: {
                    options_code:'AFTERSALE_ORDER',
                    is_member:1,        //仅查询当前用户参与的工单
                    keyword:keyword
                },
                success:data => {
                    resolve(data);
                }
            })
        },

        /*******创建、编辑提交处理方法********/
        submitHandle(status) {
            this.$refs.form.submit({
                url: this.editState?'/outsource/recruit/edit':'/outsource/recruit/add',
                rule: {
                    order_id: '请选择售后工单',
                    urgency_level: '请选择紧急程度',
                    recruit_type: '请选择招工类型',
                    recruit_count: '请输入招工人数',
                    work_days: '请输入上班天数',
                    required_fee: '请输入所需费用',
                    arrival_time: '请选择人员到岗时间'
                },
                dataFormatter: data => {
                    data.status = status;
                    return data;
                },
                success: (data, res) => {
                    if (status == 1 && res.transaction){
                        this.$refs.workflowLaunch.launch(res.transaction, () => {
                            //关闭弹窗
                            this.$refs.dialog.close();
                            // 成功回调
                            this.$message({message: this.editState ? '编辑成功' : '新增成功', type: 'success'});
                            this.$emit('resolve');
                        });
                    }else {
                        //关闭弹窗
                        this.$refs.dialog.close();
                        this.$message({message: this.editState ? '编辑成功' : '新增成功', type: 'success'});
                        //刷新列表数据
                        this.$bus.$emit('outsource_recruit_list.update', {});                    }
                }
            });
        }
    }
}
</script>

<style lang="stylus" scoped>
</style>
